import React from "react";

import { Dropdown } from "antd";

import { ReactComponent as MoreIcon } from "../../../../../assets/images/sample-submission/moreIcon.svg";

import { designTokens } from "../../../../../styles/tokens";

import "./SampleIdActionsMenu.css";

export default function SampleIdActionsMenu({
  onEditSampleId,
  onViewHistory,
  showViewHistory,
  showEditSampleId = true,
  editLabel = "Edit Sample ID",
  historyLabel = "View Log History",
}) {
  const menuItems = [];

  if (showEditSampleId && onEditSampleId) {
    menuItems.push({
      key: "edit",
      label: (
        <div className="SampleIdActionsMenu__Item" onClick={onEditSampleId}>
          <span>{editLabel}</span>
        </div>
      ),
    });
  }

  if (showViewHistory && onViewHistory) {
    menuItems.push({
      key: "view-log-history",
      label: (
        <div className="SampleIdActionsMenu__Item" onClick={onViewHistory}>
          <span>{historyLabel}</span>
        </div>
      ),
    });
  }

  if (menuItems.length === 0) {
    return null;
  }

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={["click"]}
      overlayClassName="SampleIdActionsMenu"
    >
      <MoreIcon
        className="SampleIdActionsMenu__MoreIcon"
        fill={designTokens.colorContentBase}
        width={20}
        height={20}
      />
    </Dropdown>
  );
}
